import React from 'react';

const CaretUp = () => {
  return <svg className="icon" viewBox="0 0 21.2 12.1" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m21.2 9.9-2.1 2.1-8.5-8.4-8.5 8.5-2.1-2 9.6-9.6c.6-.6 1.5-.6 2.1 0z"/></svg>
};

const CaretDown = () => {
  return <svg className="icon" viewBox="0 0 21.2 12.1" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m11.7 11.7c-.6.6-1.5.6-2.1 0l-9.6-9.7 2.1-2 8.5 8.5 8.5-8.4 2.1 2.1z"/></svg>
};

const CaretRight = () => {
  return <svg className="icon" viewBox="0 0 13 22" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m2.8 21.6-2.1-2.1 8.4-8.5-8.5-8.5 2.1-2.1 9.6 9.6c.6.6.6 1.5 0 2.1z"/></svg>
};

const ArrowsRotate = () => {
  return <svg className="icon" viewBox="0 0 19 15" width="19" xmlns="http://www.w3.org/2000/svg"><path d="M14.428 3.184C13.241 1.867 11.474 1.03 9.5 1.03c-3.571 0-6.467 2.736-6.467 6.11v1.797" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M5.315 6.063 3.033 8.938.75 6.062m3.822 5.755C5.759 13.134 7.526 13.97 9.5 13.97c3.571 0 6.467-2.736 6.467-6.11V6.062" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="m13.685 8.938 2.282-2.876 2.283 2.876" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
};

const Tick = () => {
  return <svg viewBox="0 0 15.3 11.3" className="icon" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m5.3 11.3c-.4 0-.8-.1-1.1-.4-1-1.1-2.1-2.2-3.2-3.3l-1-1.1 2.2-2.1 1 1.1c.7.7 1.4 1.5 2.1 2.2l7.9-7.7 2.1 2.1-9 8.7c-.2.4-.6.5-1 .5z"/></svg>
};

export {
  ArrowsRotate,
  CaretUp,
  CaretDown,
  CaretRight,
  Tick,
};
